<template>
    <NavigationStatusCounter
        :opened="opened"
        :visible="hasFreePlan"
        :title="t('vue.free_plan_counter_title')"
        :secondary-label="freePlanCounterLabel"
        :progress="freePlanCounterProgress"
        :progress-bar-class="freePlanCounterBarColorClass"
        progress-track-class="bg-[#2A3344]"
        :action-label="t('vue.free_plan_counter_upgrade_to_scale')"
        @action="handleUpgrade"
    />
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useTranslations } from "@/composables/useTranslations.ts";
import NavigationStatusCounter from "@/components/Navigation/NavigationStatusCounter.vue";

interface IProps {
    opened?: boolean;
    hasFreePlan?: boolean;
    freePlanLastPeriodNumberOfReport?: number | null;
}

const props = withDefaults(defineProps<IProps>(), {
    opened: false,
    hasFreePlan: false,
    freePlanLastPeriodNumberOfReport: 0,
});

const emit = defineEmits<{
    upgrade: [];
}>();

const { t } = useTranslations();

const FREE_PLAN_REPORTS_LIMIT = 5000;

const freePlanTrackedReports = computed(() => {
    const value = Number(props.freePlanLastPeriodNumberOfReport ?? 0);

    if (Number.isNaN(value) === true) {
        return 0;
    }

    return Math.max(0, Math.min(FREE_PLAN_REPORTS_LIMIT, value));
});

const freePlanCounterProgress = computed(() => {
    return (freePlanTrackedReports.value / FREE_PLAN_REPORTS_LIMIT) * 100;
});

const freePlanCounterLabel = computed<string>(() => {
    return `${freePlanTrackedReports.value} ${t(
        "vue.free_plan_counter_emails_tracked",
    )}`;
});

const freePlanCounterBarColorClass = computed(() => {
    if (freePlanTrackedReports.value >= 2700) {
        return "bg-[#FF4D4D]";
    }

    if (freePlanTrackedReports.value >= 550) {
        return "bg-[#F9CC44]";
    }

    return "bg-[#04C951]";
});

const handleUpgrade = () => {
    emit("upgrade");
};
</script>
